/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Picker_TitleInputs */

const vi_media_picker_title = /** @type {(inputs: Media_Picker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh từ thư viện`)
};

/**

* @param {Media_Picker_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_picker_title = /** @type {((inputs?: Media_Picker_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Picker_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_picker_title(inputs)
});